<p-table
  responsiveLayout="stack"
  [scrollable]="true"
  [scrollHeight]="computedTableHeight"
  [columns]="columnDefinitions"
  [reorderableColumns]="true"
  [exportFilename]="tableName"
  selectionMode="multiple"
  [resizableColumns]="true"
  stripedRows
  [value]="tableData"
  appRangeSelection
  (rangeChanged)="onRangeChanged($event)"
  [virtualScroll]="virtualScroll"
  [virtualScrollItemSize]="28"
  class="table-fixed w-full pr-2 pb-2"
>
<ng-template pTemplate="header" let-columns>
  <tr class="w-full">
    @if (tableData?.length > 0) {
      <th>
        <div class="flex flex-col w-[50px]">
          <p-splitButton
            pTooltip="Copy Table"
            icon="pi pi-copy"
            (onClick)="copyTable(columns)"
            [model]="menuItems"
            size="small"
            appendTo="body"
          ></p-splitButton>
          <p-toggleswitch
            class="mt-2"
            [ngModel]="true"
            pTooltip="Include headers when copying"
            (onChange)="headers($event)"
          ></p-toggleswitch>
        </div>
      </th>
    }

    @for (col of columns; track col.field) {
      <th 
        pResizableColumn
        (click)="toggleColumnHighlight($event, col)"
        (contextmenu)="onColumnRightClick($event, col)"
        pReorderableColumn
        class="w-[150px]"
        style="text-align: left;"
        [ngClass]="{ 'highlight-column-header': selectedColumns.includes(col.field) }"
      >
        {{ col.header }}
      </th>
    }
  </tr>
</ng-template>

  <ng-template
    pTemplate="body"
    let-rowData
    let-rIdx="rowIndex"
    let-columns="columns"
  >
    <tr (click)="clearColumnData()">
      <td class="w-[50px]">{{ rIdx + 1 }}</td>
      @for (col of columnDefinitions; track col.field) {
      <td class="text-left pl-2" [ngClass]="{ 'highlight-column': selectedColumns.includes(col.field) }">

        @if (tableName !== 'Thermal Results - Temperatures' && col.valueFormatter) {
          <div
            [ngClass]="{ 
              redFlag: rowData[col.field]?.toString().includes('*') ||
                (col.field === 'hangerLiftoffForce' && rowData[col.field] * -1 > hangerLiftoffForce) ||
                (tableName === 'Max Allowed Wear' && ['burstWear', 'collapseWear', 'combinedWear'].includes(col.field) && rowData[col.field] < 1) ||
                (tableName === 'Single Load Holliday Stress Ratio' && !['measuredDepth', 'trueVerticalDepth'].includes(col.field) && rowData[col.field] > hollidayStressRatio) ||
                (tableName === 'Packer Results Table' &&
                  ((col.field === 'latchShearLoad' && shearPinRating && rowData[col.field] > shearPinRating) ||
                    (col.field === 'total' && upwardMovementLimit != null &&
                      ((rowData[col.field] > 0 && rowData[col.field] > downwardMovementLimit && rowData[col.field] > (lengthUnit == 'ft' ? 0.0003 : 0.0001)) ||
                        (rowData[col.field] < 0 && rowData[col.field] < upwardMovementLimit && rowData[col.field] < -(lengthUnit == 'ft' ? 0.0003 : 0.0001)))))),
              orangeFlag: tableName === 'Max Allowed Wear' && ['burstWear', 'collapseWear', 'combinedWear'].includes(col.field) && rowData[col.field] < 10 && rowData[col.field] > 1
            }"
          >
              {{ col.valueFormatter(rowData[col.field]) }}
            </div>
        }

        @if (tableName === 'Thermal Results - Temperatures') {
          <div [ngStyle]="{ color: getColorForTemperature(rowData[col.field], col.field) }">
            {{ col.valueFormatter(rowData[col.field]) }}
          </div>
        }
      </td>
      }
    </tr>
  </ng-template>
</p-table>

<p-contextMenu #compareMenu [model]="compareContextMenuItems" appendTo="body"></p-contextMenu>